import "./screen-size";
import "./navigation";
import "./table-of-contents";
import "./togglize";
import "./columnize";
import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";
import "./hero-video";
import "./properties";
import sal from "./sal.js";

(function ($) {
  $(document).ready(function () {
    console.log("starter theme...");

    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play");
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    let $faqToggles = $(".faq-column").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false, adaptiveHeight: true });
    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.75s" });
    let twoCols = $(".two-col-content").twoColumnize();

    $(".testimony-slider").slick({
      infinite: true,
      slidesToShow: 1,
      dots: true,
      arrows: false,
      rows: 0
    });

    /**
     * Copy Email Address to Clipboard
     */
    // $("#team-member-list").on("click", ".email-copy-button", function (e) {
    //   let $emailButton = $(this);
    //   let email = $emailButton.data("email");
    //   navigator.clipboard.writeText(email).then(
    //     function copySuccess() {
    //       let emailButtonOriginalContent = $emailButton.html();
    //       $emailButton.text("Email Copied to Clipboard!");
    //       setTimeout(function resetToOldText() {
    //         $emailButton.html(emailButtonOriginalContent);
    //       }, 5000);
    //     },
    //     function copyFailed() {
    //       $emailButton.parent().append($(`<span>Your Browser Does Not Support the Clipboard</span><br><span class='fit-email'>${email}</span>`));
    //       $emailButton.remove();
    //     }
    //   );

    // Community filters
    $(document).on("change", ".js-filter-form", function (e) {
      console.log("it works");
      e.preventDefault();

      // var category = $(this).data("category");

      // $.ajax({
      //   url: "wpAjax.ajaxUrl",
      //   data: {
      //     action: "filter",
      //     category: category
      //   },
      //   type: "post",
      //   success: function (result) {
      //     $(".js-filter").html(result);
      //   },
      //   error: function (results) {
      //     console.log(results);
      //   }
      // });
    });

    $(".standard-slider").slick({
      lazyLoad: "ondemand",
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // centerMode: true,
      // centerPadding: '40px',
      // autoplay: true,
      // autoplaySpeed: 6000,
      rows: 0,
      infinite: true
      // appendArrows: ".append-slick-arrows",
      // responsive: [
      //   {
      //     breakpoint: 1199,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 1,
      //       lazyLoad: "ondemand",
      //       arrows: false,
      //       dots: true
      //     }
      //   },
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       arrows: false,
      //       dots: true
      //     }
      //   }
      // ]
    });

    $(".triple-image-slider").slick({
      lazyLoad: "ondemand",
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      // centerMode: true,
      // centerPadding: '40px',
      // autoplay: true,
      // autoplaySpeed: 6000,
      arrows: true,
      nextArrow: `<button type="button" class="carousel-button carousel-next">
										<svg aria-hidden="true" focusable="false"  xmlns="http://www.w3.org/2000/svg" height="24" viewBox="400 -710 50 460" width="24"><path d="m517.847-480-184-184L376-706.153 602.153-480 376-253.847 333.847-296l184-184Z"/></svg>
										<span class="sr-only">Next Image</span>
									</button>`,
      prevArrow: `<button type="button" class="carousel-button carousel-prev">
										<svg  aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="480 -710 50 460" width="24"><path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"/></svg>
										<span class="sr-only">Previous Image</span>
									</button>`,
      rows: 0,
      infinite: true,
      // appendArrows: ".append-slick-arrows",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: "ondemand",
            arrows: false,
            dots: true,
            adaptiveHeight: true
          }
        }
        // {
        //   breakpoint: 768,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: false,
        //     dots: true
        //   }
        // }
      ]
    });

    sal();

    if ($(".tabbed").length) {
      // Get relevant elements and collections
      const tabbed = document.querySelector(".tabbed");
      const tablist = tabbed.querySelector("ul");
      const tabs = tablist.querySelectorAll("a");
      const panels = tabbed.querySelectorAll('[id^="section"]');

      // The tab switching function
      const switchTab = (oldTab, newTab) => {
        newTab.focus();
        // Make the active tab focusable by the user (Tab key)
        newTab.removeAttribute("tabindex");
        // Set the selected state
        newTab.setAttribute("aria-selected", "true");
        oldTab.removeAttribute("aria-selected");
        oldTab.setAttribute("tabindex", "-1");
        // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide
        let index = Array.prototype.indexOf.call(tabs, newTab);
        let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;
      };

      // Add the tablist role to the first <ul> in the .tabbed container
      tablist.setAttribute("role", "tablist");

      // Add semantics are remove user focusability for each tab
      Array.prototype.forEach.call(tabs, (tab, i) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", "tab" + (i + 1));
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation");

        // Handle clicking of tabs for mouse users
        tab.addEventListener("click", e => {
          e.preventDefault();
          let currentTab = tablist.querySelector("[aria-selected]");
          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        });

        // Handle keydown events for keyboard users
        tab.addEventListener("keydown", e => {
          // Get the index of the current tab in the tabs node list
          let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
          // Work out which key the user is pressing and
          // Calculate the new tab's index where appropriate
          let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? "down" : null;
          if (dir !== null) {
            e.preventDefault();
            // If the down key is pressed, move focus to the open panel,
            // otherwise switch to the adjacent tab
            dir === "down" ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
          }
        });
      });

      // Add tab panel semantics and hide them all
      Array.prototype.forEach.call(panels, (panel, i) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "-1");
        let id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
      });

      // Initially activate the first tab and reveal the first tab panel
      tabs[0].removeAttribute("tabindex");
      tabs[0].setAttribute("aria-selected", "true");
      panels[0].hidden = false;
    }

    $(".page-section--full_bleed .multi-column.normal:nth-child(even) .prose").attr("data-sal", "slide-left");

    $("section.page-section.main-copy .multi-column.normal .column:last-child .prose").attr("data-sal", "slide-left");

    $("section.page-section.standard-section .multi-column.reverse .column:first-child .prose").attr("data-sal", "slide-left");

    $(".vr-button").magnificPopup({
      type: "inline",
      closeOnContentClick: true,
      iframe: {
        markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + "</div>" // HTML markup of popup, `mfp-close` will be replaced by the close button
      }
    });

    // Magnific popup gallery
    $(".gallery-lightbox-image").magnificPopup({
      type: "image",
      gallery: {
        enabled: true
      },
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` di
      },
      verticalFit: true // Fits image in area vertically
    });

    $(".grid-gallery").each(function (e) {
      $(this).magnificPopup({
        delegate: "a",
        type: "image",
        gallery: {
          enabled: true,
          navigateByImgClick: true,

          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

          tPrev: "Previous (Left arrow key)", // title for left button
          tNext: "Next (Right arrow key)", // title for right button
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
        }
      });
    });
  });
})(jQuery);
